(() => {
  const initialize = root => {
    if (root.dvnController) return;
    const controller = new AbortController();
    root.dvnController = controller;
    const { signal } = controller;
    const listen = (element, name, callback) => element.addEventListener(name, callback, { signal });
    const shell = root.querySelector('.dvn-nav-shell');
    const buttons = [...root.querySelectorAll('[data-menu]')];
    const drawer = root.querySelector('.dvn-mobile-drawer');
    const shade = root.querySelector('.dvn-mobile-shade');
    const opener = root.querySelector('.dvn-mobile-open');
    const closer = root.querySelector('.dvn-drawer-close');
    const desktop = window.matchMedia('(min-width:921px)');
    let active = null;
    let closeTimer;
    let previousFocus;
    let savedOverflow = '';
    let savedPadding = '';
    const isolated = new Map();
    const panelFor = button => document.getElementById(button.getAttribute('aria-controls'));
    const hide = () => {
      clearTimeout(closeTimer);
      active = null;
      buttons.forEach(button => {
        button.setAttribute('aria-expanded', 'false');
        panelFor(button).hidden = true;
      });
    };
    const show = button => {
      if (!desktop.matches) return;
      clearTimeout(closeTimer);
      active = button;
      buttons.forEach(candidate => {
        const open = candidate === button;
        candidate.setAttribute('aria-expanded', String(open));
        panelFor(candidate).hidden = !open;
      });
    };
    const focusable = () => [...drawer.querySelectorAll('a[href],button,input,select,[tabindex="0"]')].filter(el => el.getClientRects().length && !el.closest('[hidden]'));
    const setDrawer = (open, returnFocus = true) => {
      const isOpen = drawer.classList.contains('dvn-on');
      if (open === isOpen) return;
      hide();
      if (open) {
        previousFocus = document.activeElement;
        savedOverflow = document.body.style.overflow;
        savedPadding = document.body.style.paddingRight;
        const gap = window.innerWidth - document.documentElement.clientWidth;
        document.body.style.overflow = 'hidden';
        if (gap > 0) document.body.style.paddingRight = `${gap}px`;
        let branch = drawer;
        while (branch && branch !== document.body) {
          [...branch.parentElement.children].forEach(sibling => {
            if (sibling !== branch && sibling !== shade && !isolated.has(sibling)) {
              isolated.set(sibling, sibling.inert);
              sibling.inert = true;
            }
          });
          branch = branch.parentElement;
        }
      }
      document.documentElement.classList.toggle('dvn-drawer-open', open);
      drawer.classList.toggle('dvn-on', open);
      shade.classList.toggle('dvn-on', open);
      opener.setAttribute('aria-expanded', String(open));
      drawer.setAttribute('aria-hidden', String(!open));
      drawer.inert = !open;
      if (open) requestAnimationFrame(() => { if (drawer.classList.contains('dvn-on')) closer.focus(); });
      else {
        document.body.style.overflow = savedOverflow;
        document.body.style.paddingRight = savedPadding;
        isolated.forEach((wasInert, element) => element.inert = wasInert);
        isolated.clear();
        if (returnFocus && previousFocus?.isConnected) previousFocus.focus();
      }
    };
    drawer.inert = true;
    buttons.forEach(button => {
      listen(button, 'pointerenter', event => { if (event.pointerType === 'mouse') show(button); });
      listen(button, 'click', () => active === button ? hide() : show(button));
      listen(button, 'keydown', event => {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          show(button);
          panelFor(button).querySelector('a')?.focus();
        }
      });
    });
    listen(shell, 'mouseenter', () => clearTimeout(closeTimer));
    listen(shell, 'mouseleave', () => closeTimer = setTimeout(hide, 140));
    listen(shell, 'focusout', event => {
      if (!shell.contains(event.relatedTarget)) hide();
    });
    listen(document, 'pointerdown', event => {
      if (!shell.contains(event.target)) hide();
    });
    listen(opener, 'click', () => setDrawer(true));
    listen(closer, 'click', () => setDrawer(false));
    listen(shade, 'click', () => setDrawer(false));
    const accordions = [...drawer.querySelectorAll('[data-accordion]')];
    accordions.forEach(button => listen(button, 'click', () => {
      const expand = button.getAttribute('aria-expanded') !== 'true';
      accordions.forEach(candidate => {
        const open = candidate === button && expand;
        candidate.setAttribute('aria-expanded', String(open));
        document.getElementById(candidate.getAttribute('aria-controls')).hidden = !open;
      });
    }));
    listen(document, 'keydown', event => {
      if (event.key === 'Escape') {
        if (drawer.classList.contains('dvn-on')) setDrawer(false);
        else if (active) {
          const trigger = active;
          hide();
          trigger.focus();
        }
      }
      if (event.key === 'Tab' && drawer.classList.contains('dvn-on')) {
        const items = focusable();
        const first = items[0];
        const last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault(); first.focus();
        }
      }
    });
    listen(desktop, 'change', () => {
      hide();
      if (desktop.matches) setDrawer(false, false);
    });
    root.dvnDispose = () => {
      setDrawer(false, false);
      clearTimeout(closeTimer);
      controller.abort();
      delete root.dvnController;
    };
  };
  const boot = scope => {
    if (scope.matches?.('[data-dvn-menu]')) initialize(scope);
    scope.querySelectorAll('[data-dvn-menu]').forEach(initialize);
  };
  boot(document);
  if (!window.dvnMenuEditorEvents) {
    window.dvnMenuEditorEvents = true;
    document.addEventListener('shopify:section:load', event => boot(event.target));
    document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-dvn-menu]').forEach(root => root.dvnDispose?.()));
  }
})();
